import React from "react";
import "../css/Contact.css";

const Contact = () => {
  return (
    <div className="contact7">

      {/* ================= HERO ================= */}
      <section className="c7-hero">
        <h1>Contact PULSE</h1>
        <p>Train smarter. Reach us directly.</p>
      </section>


      {/* ================= INFO GRID ================= */}
      <section className="c7-info">

        <div className="c7-card">
          <h3>Location</h3>
          <p>Downtown Fitness District</p>
          <p>221 Iron Street</p>
          <p>New York, NY 10012</p>
        </div>

        <div className="c7-card">
          <h3>Hours</h3>
          <p>Monday – Friday: 6am – 10pm</p>
          <p>Saturday: 7am – 8pm</p>
          <p>Sunday: 8am – 6pm</p>
        </div>

        <div className="c7-card">
          <h3>Contact</h3>
          <p>+1 800 555 0923</p>
          <p>train@pulsegym.com</p>
          <p>@pulsegym</p>
        </div>

      </section>


      {/* ================= MAP ================= */}
      <section className="c7-map">
        <iframe
          title="Pulse Gym Location"
          src="https://www.google.com/maps?q=New+York+City&output=embed"
          loading="lazy"
        ></iframe>
      </section>


      {/* ================= STRIP ================= */}
      <section className="c7-strip">
        <h2>Step In. Feel The Energy.</h2>
        <p>Your training starts when you show up.</p>
      </section>

    </div>
  );
};

export default Contact;
